import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

/**
 * Guard that redirects /pricing/:product routes to the pricing modal
 * with the product as a query parameter.
 * 
 * Example: /pricing/automate -> /home(modal:pricing)?product=automate
 */
export const PricingRedirectGuard: CanActivateFn = (route) => {
	const router = inject(Router);
	const product = route.paramMap.get('product');

	router.navigate(
		[{ outlets: { modal: 'pricing', primary: 'home' } }],
		{ queryParams: product ? { product } : undefined }
	);

	return false;
};
